var DEV = process.env.NODE_ENV !== "production";
var specialProperties = ["__proto__", "constructor", "prototype"];

var identity = function identity(x) {
  return x;
};

var is = function is(n) {
  return n !== void 0 && n !== null;
};

var num = function num(n) {
  return typeof n === "number" && !Number.isNaN(n);
};

var string = function string(n) {
  return typeof n === "string" && n !== "";
};

var obj = function obj(n) {
  return typeof n === "object" && n !== null;
};

var func = function func(n) {
  return typeof n === "function";
};

var negative = function negative(n) {
  return num(n) && n < 0;
};

var get = function get(from, path) {
  var paths = String(path).split(".");
  var pathsLength = paths.length;
  var result = from;

  for (var i = 0; i < pathsLength; i += 1) {
    if (!is(result)) return result;
    var path2 = paths[i];
    result = is(result[path2]) ? result[path2] : void 0;
  }

  return result;
};

var assign = function assign(target, source) {
  if (!is(source)) return target;

  for (var key in source) {
    if (specialProperties.indexOf(key) !== -1) {
      continue;
    }

    target[key] = source[key];
  }

  return target;
};

var merge = function merge(target, source) {
  if (!is(source)) return target;

  for (var key in source) {
    if (specialProperties.indexOf(key) !== -1) {
      continue;
    }

    if (obj(target[key])) {
      target[key] = merge(assign({}, target[key]), source[key]);
    } else {
      target[key] = source[key];
    }
  }

  return target;
};

var warn = function warn(condition, message) {
  if (DEV) {
    if (!condition && console.error) {
      console.error(message);
    }
  }
};

function cascade(value, arg) {
  if (typeof value === "function") {
    return cascade(value(arg), arg);
  }

  return value;
}

var getThemeValue = function getThemeValue(props, path) {
  var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : props.theme;
  return cascade(get(initial, path), props);
};

function omit(object, values) {
  var result = {};

  for (var key in object) {
    if (values.indexOf(key) === -1) {
      result[key] = object[key];
    }
  }

  return result;
}

function flattenStrings(array) {
  return array.reduce(function (flattenedArray, value) {
    var lastIndex = flattenedArray.length - 1;
    var last = flattenedArray[lastIndex];

    if (typeof last === "string" && typeof value === "string") {
      flattenedArray[lastIndex] = last + value;
    } else {
      flattenedArray.push(value);
    }

    return flattenedArray;
  }, []);
}

function flattenDown(array, result) {
  for (var i = 0; i < array.length; i++) {
    var value = array[i];

    if (Array.isArray(value)) {
      flattenDown(value, result);
    } else {
      result.push(value);
    }
  }

  return result;
}

function flatten(array) {
  return flattenDown(array, []);
}

export { assign, cascade, flatten, flattenStrings, func, get, getThemeValue, identity, is, merge, negative, num, obj, omit, string, warn };